module.exports = __webpack_public_path__ + "img/14_36.463b51b5.png";